import publicUrls from "../../../routes/publicUrls";
import React, { useState, useEffect } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { lafuerzaAuction } from "../../../Model/Auction";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import lafuerza from "./../../../images/resources/lafuerza.png";
import lafuerza1 from "./../../../images/resources/lafu1.jpg";
import lafuerza2 from "./../../../images/resources/lafu2.jpg";
import lafuerza3 from "./../../../images/resources/lafu3.jpg";

const View = (props) => {
  const matches = useMediaQuery("(min-width:1000px)");
  const itemData = [
    {
      img: lafuerza1,
      title: "Breakfast",
      rows: 2,
      cols: 2,
    },
    {
      img: lafuerza2,
      title: "Coffee",
      author: "@arwinneil",

      cols: 2,
    },
    {
      img:lafuerza3,
      title: "Coffee",
      author: "@arwinneil",
    
      cols: 2,
    },
  ];

  function srcset(image, size, rows = 1, cols = 1) {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${
        size * rows
      }&fit=crop&auto=format&dpr=2 2x`,
    };
  }

  const [auction, setAuction] = useState([]);
 
  
  const [loading,setLoading] = useState(false)


  const FetchData = (auction_status) => {
    setLoading(true);
  
    async function getAuctionOne() {
      try {
        const results = await lafuerzaAuction(auction_status);
  
        if (!results || results.success === false || results.length === 0) {
          setAuction([]); // IMPORTANT
        } else {
          setAuction(results);
        }
      } catch (error) {
        console.error(error);
        setAuction([]);
      } finally {
        setLoading(false);
      }
    }
  
    getAuctionOne();
  };
  

  useEffect(() => {
    FetchData()
  }, []);

  const [active,setActive] = useState(false)
  const [active1,setActive1] = useState(false)
  const handleUpcomming = (searchValue) => {
    if(searchValue=== 'UPCOMING'){
      setActive(true)
      setActive1(false)
    }else{
      setActive(false)
      setActive1(true)
    }

    return FetchData(searchValue)
  };


  const GotoPage = (id, slug, type, imageCover) => {
    localStorage.setItem("items", id);
    localStorage.setItem("cover", imageCover);

    if (type === "EXHIBITION") {
      window.location.href = publicUrls.exhibition(slug, id);
    } else {

      window.location.href = publicUrls.auction(slug, id);
      // window.location.href = `/auction/lot/${id}/${slug}/${type}`;
      // window.location.href = `/auction/lot/${slug}/${type}`;
    }
  };


  return (
    <div className="boxed_wrapper">
      <section
        className="breadcrumb-area"
        style={{padding: "185px 0 25px"}}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
            <img style={{ width: "100%" }} src={lafuerza} />
            

            </div>
          </div>
        </div>
      </section>

      <section className="events-single-area" style={{    padding: "50px 0 0"}}>
        <div className="container">
          
          <div className="row">
            <div className="col-xl-8">
              <div className="events-single-text-box">
                <h2>Leon Gallery Lafuerza</h2>
                <p>
                LeonExchange serves as your digital portal to discover your next treasure. Conducted quarterly, it acts as a curated hub for vintage, high-quality, and previously cherished items sourced from distinguished collections and esteemed estates. Whether you're a collector of art, jewelry, furniture, decor, or more, each auction promises an opportunity to uncover your next beloved piece.
                </p>
          
              </div>
            </div>
            <div className="col-xl-4">
              <div className="events-single-info-box">
                <ul className="events-info">
                  <li>
                    <p>Type :</p>
                    <span>Gallery Talk</span>
                  </li>
                  <li>
                    <p>Hours :</p>
                    <span>Monday–Saturday 9:00 AM - 6:00 PM</span>
                  </li>
                  <li>
                    <p>Venue :</p>
                    <span>
                    León Gallery, W14 La Fuerza Plaza, 2241 Chino Roces Ave, Makati
                    </span>
                  </li>
                </ul>
                <div className="social-links">
                  <p>Shear :</p>
                  <ul className="sociallinks-style-two">
                    <li>
                      <a href="#">
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-youtube-play" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      <section className="gallery-area">
        <div className="layer-outer"></div>
        <div className="container">
          <div className="visit-day-select">
            <h1>Online Auction</h1>

            <div className="sec-title text-center" style={{ paddingTop: 20 }}>
              <ul className="tab-btns tab-buttons text-center clearfix">
              <li
                
                data-tab="#today"
                className={`tab-btn ${active === true ? 'active-btn': ''}`}
                onClick={() => handleUpcomming("UPCOMING")}
              >
                <span>Upcoming</span>
              </li>
              <li
                data-tab="#tomorrow"
                className={`tab-btn ${active1 === true ? 'active-btn': ''}`}
                onClick={() => handleUpcomming("PREVIOUS")}
              >
                <span>Past</span>
              </li>
                
              </ul>
            </div>
          </div>

          
{loading && (
  <Box
    sx={{
      textAlign: "center",
      padding: "40px 0",
    }}
  >
    <CircularProgress size="3rem" />
  </Box>
)}


{!loading && auction.length === 0 && (
  <Box
    sx={{
      textAlign: "center",
      padding: "60px 20px",
      color: "#555",
    }}
  >
    <h3 style={{ marginBottom: 10 }}>
      No Upcoming Auctions at this time
    </h3>
    <p style={{ fontSize: 15 }}>
      Please check back later or explore our past auctions.
    </p>
  </Box>
)}


{!loading && auction.length > 0 && (
  <div className="row items-container clearfix">
    {auction.map((val) => {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      const startDate = new Date(val.date_start);
      const endDate = new Date(val.date_end);

      return (
        <div
          key={val.id}
          className="col-xl-4 col-lg-6 col-md-6 col-sm-12 masonry-item"
        >
          <div className="single-art-box-style2 marbtm50">
            <div
              style={{ cursor: "pointer", color: "#212529" }}
              onClick={() =>
                GotoPage(val.id, val.c_slug, val.c_type, val.cover)
              }
            >
              <div
                style={{
                  backgroundImage: `url(${
                    val.cover ??
                    "https://placehold.co/440x623?text=NO+IMAGE"
                  })`,
                  height: matches ? 600 : 420,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />

              <div className="text-holder">
                <h3>{val.d_name}</h3>
                <span>
                  {startDate.toLocaleDateString("en-US", options)} to{" "}
                  {endDate.toLocaleDateString("en-US", options)}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
)}


            <ImageList
              sx={{ width:' 100%' ,paddingBottom:10}}
              variant="quilted"
              cols={4}
              rowHeight={matches === true ? 300: 120}
            >
              {itemData.map((item) => (
                <ImageListItem
              
                  key={item.img}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                >
                  <img
          
                    {...srcset(item.img, 121, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                  />
                </ImageListItem>
              ))}
            </ImageList>

        </div>
      </section>
    </div>
  );
};

export default View;
